import type { VideoModelConfig } from '../../types';

/** Wan2.2（仅 5s） */
export const wan2_2: VideoModelConfig = {
  id: '01K5THVBNHF0QDSG0Y3C5PNW00',
  displayName: 'Wan2.2',
  defaults: {
    resolution: '720P',
    duration: 5,
  },
  resolutionOptions: [
    { label: '480P', value: '480P' },
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'options', options: [5] },
  capabilities: {},
  limits: {
    maxRefImages: 1,
  },
};
